import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import ReactTable  from "react-table";
import {getToken, getDateRange} from '../../storage'
import {DRN} from './daterange'
import {Currency} from '../../utils/currency'
import {ColumnSummation} from '../../utils/misc'

export default class BrandSales extends React.Component {
  constructor() {
    super();
    let dateRange = getDateRange();
    this.state = {
      tableState: {},
      data: [],
      pages: null,
      loading: true,
      dateRange : dateRange
    };

    document.title = "Brand Sales"
  }

  profitFormat =(row)=> {

    let quantity=parseFloat(row.original.quantity), selling_rate=parseFloat(row.original.selling_basic_rate), purchase_rate= parseFloat(row.original.purchase_basic_rate)
    let profit = parseFloat((selling_rate-purchase_rate)*quantity).toFixed(2)
    return parseFloat(profit)
  }

  handleTrclick =(state,row, column, instance) =>{
    return {
      onClick : (e, handleOriginal)=>{
        this.props.history.push('/reports/items_sale_report/'+row.original.item__brand__id)
      },
      style: {
        cursor:'pointer'
      }
    }
  }


  fetchData =(state, instance, dateRange=this.state.dateRange)=> {
    this.setState({ loading: true });
    let apiurl = "/list_brand_sales/?page=" + state.page + "&page_size="+state.pageSize;
    if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
        apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
        apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
    }
    if(dateRange) {
      let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
      let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
      let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
      let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
      apiurl = apiurl + "&start_date="+start_date+"&end_date="+end_date
    }
    this.setState({tableState:state})
    axios({
      url: apiurl,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then(res => {
      this.setState({
        data: res.data.brand_sales,
        pages: res.data.pages,
        loading: false
      });
    }).catch((err)=>{
      this.setState({loading:false})
    })
  }

  applyDateRange =(dateRange)=>{
    this.fetchData(this.state.tableState, {}, dateRange)
  }


  render() {
    let purchaseHeader = <span><Currency /> Purchase</span>
    let salesHeader = <span><Currency /> Sales</span>
    let profitHeader = <span><Currency /> Profit</span>

    const { data, pages, loading } = this.state;
    const columns = [
      {Header:'Brand Name', sortable:true, Cell:(row)=>(<div className="text-primary">{row.original.item__brand__name}</div>)},
      {Header:'Total Items', accessor: 'sales', sortable:true, Cell:(row)=>(<div className="text-right">{row.original.sales}</div>)},
      {Header: purchaseHeader, accessor: 'purchase_amount',
        sortable:true, Cell:(row)=>(<div className="text-right">{row.original.purchase_amount}</div>),
        Footer:<ColumnSummation data={data} sumof='purchase_amount' />

      },
      {Header: salesHeader, accessor: 'sale_amount', sortable:true,
        Cell:(row)=>(<div className="text-right">{row.original.sale_amount}</div>),
        Footer:<ColumnSummation data={data} sumof='sale_amount' />
      },
      {Header: profitHeader, accessor: 'profit', Cell:(row)=>(<div className="text-right">{row.original.profit}</div>),  sortable:true, Footer:<ColumnSummation data={data} sumof="profit" />},
    ]

    return <div >
    <section className="medium">
      <div className="row">
        <div className="col-sm-5">
          <h3>All Brand Sales</h3>
        </div>
        <div className="col-sm-3 col-sm-offset-4">
          <DRN applyDateRange={this.applyDateRange} dateRange={this.state.dateRange} />
        </div>
      </div>
    </section>
    <div className="row">
      <div className="col-sm-12">
        <div className="table-responsive">
          <ReactTable
            noDataText="No Records Found."
              getTrProps={this.handleTrclick}
              columns={columns} manual data={data}
              pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
        </div>

      </div>
    </div>
      </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/report/brandsalesummary.js